<script setup lang="ts">
import transfer from "@/assets/integral/transfer.png";
import recieve from "@/assets/integral/recieve.png";
import moment from "moment";
import clipboard3 from "vue-clipboard3";
import { showToast } from "vant";
import { useI18n } from "vue-i18n";
import { useAccountStore } from "@/stores/account";
import { computed } from "vue";
import { useRoute } from "vue-router";
const { toClipboard } = clipboard3();
const { t } = useI18n();
const route = useRoute()
const accountStore = useAccountStore();
console.log(history.state);

const state = history.state
const handleCopy = async (text: string) => {
  await toClipboard(text);
  showToast(t("Copied"));
};

const accountName = computed(() => {
  return accountStore.getUserInfo.name;
});

const linkJump = () => {
  window.location.href = `${import.meta.env.VITE_APP_AMAX_SCAN}/transaction/${
    state.traceId
  }`;
};
</script>

<template>
  <div class="layout">
    <div class="box header">
      <img :src="transfer" alt="" v-if="state.fromAccount === accountName" />
      <img :src="recieve" alt="" v-else />
      <div class="info">
        {{ state.fromAccount === accountName ? "-" : "+" }}
        {{ state.tokenValue }}STAR
        <span class="text">签到奖励</span>
      </div>
    </div>
    <div class="detail box">
      <div class="row">
        <div class="name">发送方</div>
        <div class="ct">
          <div class="left">{{ state.fromAccount }}</div>
          <div class="right">
            <i
              class="copy"
              @click="
                () => {
                  handleCopy(state.fromAccount);
                }
              "
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="name">接收方</div>
        <div class="ct">
          <div class="left">{{state.toAccount}}</div>
          <div class="right">
            <i
              class="copy"
              size="{18}"
              @click="
                () => {
                  handleCopy(state.toAccount);
                }
              "
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="name">Memo</div>
        <div class="ct">
          <div class="left">{{ state.transferMemo }}</div>
        </div>
      </div>
    </div>
    <div class="detail box">
      <div class="row">
        <div class="name">哈希值</div>
        <div class="ct">
          <div class="left">
            {{
              `${state.traceId.slice(0, 9)}...${state.traceId.slice(
                -16,
                state.traceId.length
              )}`
            }}
          </div>
          <div class="right">
            <i
              class="copy"
              size="{18}"
              @click="
                () => {
                  handleCopy(state.traceId);
                }
              "
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="name">区块号</div>
        <div class="ct">
          <div class="left">{{ state.blockNum }}</div>
          <div class="right">
            <i
              class="copy"
              size="{18}"
              @click="
                () => {
                  handleCopy(state.blockNum);
                }
              "
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="name">交易时间</div>
        <div class="ct">
          <div class="left">
            {{ moment(state.createTime * 1000).format("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="name">查询链接</div>
        <div class="ct">
          <div class="left link" @click="linkJump">点击查询详细信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout {
  padding: 0 12px;
  height: 100%;
  min-height: 100vh;
  background: #070b14;
  padding-top: 12px;
  .box {
    display: flex;
    width: 100%;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 22px;
    border-radius: 12px;
    background: #1f212d;
    margin-bottom: 12px;
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    img {
      width: 44px;
    }
    .info {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: $text1;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      .text {
        color: $text2;
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  .detail {
    .row {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      .name {
        color: $text2;
        font-family: "Noto Sans SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .ct {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          color: $text1;
          font-family: Poppins;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          &.link {
            color: #1cf2e4;
          }
        }
      }
    }
  }
}
</style>
